import { css } from 'lit';

export const Q1MemberSelectListStyles = css`

  :host {
    display: block;
  }

  :host([required]) label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
    box-sizing: inherit;
    font-size: var(--sl-input-label-font-size-medium);
    margin-left: 0.2rem;
  }

  /*=== BASE LAYOUT & SHARED STYLES ===*/

  #component-base {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  item-spacer {
    display: inline-block;
    flex: 1 1 0;
  }

  /*=== SELECTED MEMBERS SECTION ===*/

  #selected-wrapper {
    flex: 1 1 40%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .selected-member-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.5rem 0.5rem 0;
  }

  .selected-member-item sl-icon-button::part(base) {
    color: var(--gray-5);
  }
  .selected-member-item sl-icon-button::part(base):hover,
  .selected-member-item sl-icon-button::part(base):focus {
    color: var(--gray-7);
  }

  #selected-member-placeholder {
    font-size: 0.8rem;
    font-style: italic;
    font-weight: 100;
    
    color: var(--gray-6);
    background: var(--gray-1);
    padding: 0.9rem 1.1rem;
    border: 1px dashed var(--gray-3);
    border-radius: var(--sl-border-radius-small);
  }

  #maxlength-info {
    font-style: italic;
    font-weight: 100;
    color: var(--gray-6);
    padding: 0rem 2rem 0.5rem 2rem;
  }
  #maxlength-info.warning {
    color: var(--gray-8);
    font-style: normal;
  }
  #maxlength-info.danger {
    color: var(--red-7);
    font-weight: 500;
  }

  /*=== SEARCH SECTION ===*/

  #search-wrapper {
    flex: 1 1 60%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  #member-list {
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: var(--sl-input-border-radius-medium);
    overflow-y: scroll;
    overflow-x: hidden;

    height: calc(3rem * var(--rows, 5));
  }

  #search-list-placeholder {
    font-style: italic;
    font-weight: 100;
    color: var(--gray-6);
    padding: 0.9rem 1.1rem;
  }

  .search-member-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background: white;
    border: 1px solid var(--gray-1);
    margin: -1px; /* to prevent double borders */
    cursor: pointer;

    transition: all 0.2s ease-in-out;
  }
  .search-member-item.disabled {
    cursor: not-allowed;
  }
  .search-member-item:hover,
  .search-member-item:focus {
    background: var(--gray-1);
  }
  .search-member-item.selected {
    font-weight: 600;
    background: var(--gray-1);
    border-color: var(--gray-2);
  }
  .search-member-item.selected:hover,
  .search-member-item.selected:focus {
    background: var(--gray-3);
  }

  .search-member-item .label {
    font-size: 0.9rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0.5rem 0.25rem 0.75rem;
    border-radius: var(--sl-border-radius-small);
  }
  .search-member-item .label.disabled {
    color: var(--gray-5);
    font-style: italic;
  }
  .search-member-item .label.selected {
    color: var(--sl-color-primary-600);
    background: var(--sl-color-primary-300);
    font-style: normal;
  }

  .search-member-item .label sl-icon {
    font-size: 1.2rem;
  }
  
`;
